import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router';
import { User } from '../../../../shared/types';
import { useAdminUsers } from '../../../hooks/useAdminUsers';
import { UserForm } from './UserForm';

export const UserEdit = () => {
    const { id } = useParams<{ id: string }>();
    const [selectedUser, setSelectedUser] = useState<User>();
    const { data: users = [], isFetched } = useAdminUsers();

    useEffect(() => {
        if (!isFetched) return;

        const user = users.find((user) => user._id.toString() === id!);

        if (user) setSelectedUser(user);
    }, [id, isFetched]);

    if (!selectedUser) return null;

    return <UserForm user={selectedUser}  />;
};
